import { Row, Button } from "antd";
import { useCallback, useState } from "react";
import { HelpModal } from "../../../HelpModal";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { useLogoRedirectPath } from "../../../../lib/hooks/useLogoRedirectPath";
import { MobileMenu } from "../Admin/MobileMenu";
import { useLogout } from "../../hooks/useLogout";
import Logo from "../Logo";
import ProfileLink from "../ProfileLink";
import { useHasMessagesAccess } from "../../../../lib/hooks/useHasMessagesAccess";
import { useHasNotifications } from "../../hooks/useHasNotifications";
import { useSelector } from "react-redux";
import { ScopeSpecificLink } from "../ScopeSpecificLink";
import { MessageOutlined } from "@ant-design/icons";
import ROUTES from "../../../../configs/routesConfig";
import "../../styles.scss";

export const UserHeader = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { logoRedirectPath } = useLogoRedirectPath();

  const { onLogout } = useLogout();

  const openModal = useCallback(() => setIsModalOpen(true), []);

  const { canViewMessages } = useHasMessagesAccess();

  const user: any = useSelector((state: any) => state.auth.user);

  const hasUnreadMessages = useSelector((state: any) => state.unreadMessages.hasNotification);

  useHasNotifications();

  return (
    <>
      <Row className="justify-space-between logged-header__container">
        <Row>
          <Link className="py-5" to={logoRedirectPath} id={logoRedirectPath}>
            <Logo />
          </Link>
        </Row>
        <Row>
          {canViewMessages && (
            <ScopeSpecificLink hasNotification={hasUnreadMessages} icon={<MessageOutlined />} route={ROUTES.MESSAGES} />
          )}
          <ProfileLink user={user} />
          <Button type="text" className="header-button" onClick={openModal}>
            Help
          </Button>
          <Button type="text" className="header-button desktop-btn" onClick={onLogout}>
            Log out
          </Button>
          <MobileMenu onLogoutClicked={onLogout} />
        </Row>

        <HelpModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      </Row>

      <Outlet />
    </>
  );
};
